import React, { memo, useMemo } from "react";
import classNames from "classnames";
import isUndefined from "lodash/isUndefined";
import getShorterText from "Common/componentUtils/getShorterText";
import isString from "lodash/isString";
import TextWidget from "Components/optionForm/widgets/textWidget";
function TogglerWithFloatLabel(props) {
    const defaultContent = useMemo(() => {
        if (isString(props.caption)) {
            const resultCaption = isUndefined(props.selectedKeyCaption)
                ? props.caption
                : getShorterText(props.selectedKeyCaption, props.maxLength);
            return resultCaption === null ? undefined : resultCaption;
        }
        return undefined;
    }, [props.maxLength, props.caption, props.selectedKeyCaption]);
    return (React.createElement("div", { onClick: () => {
            if (!props.disabled && props.onClick)
                props.onClick();
        }, id: props.id },
        React.createElement(TextWidget, { className: classNames(props.open && "active dx-state-focused dx-state-active", !props.height && "h-auto", props.validationStatus === "invalid" && "error", props.className), label: props.label, labelMode: "floating", inputAttr: {
                readOnly: true
            }, value: props.open && !defaultContent ? " " : defaultContent, disabled: props.disabled, height: props.height })));
}
export default memo(TogglerWithFloatLabel);
